import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { ExpenseTotal } from "~/components/Expenses/ExpenseTotal";
import { useExpensesTotalInfo } from "~/repository/useExpensesTotalInfo";
import { getCurrencyCodeByProjectId } from "~/store/selectors/selector.currencies";
import ExpenseTotalRealtimeEvents from "./ExpenseTotalRealtimeEvents";

export const ExpenseParentTotalContainer = ({
  parentType,
  parentId,
  projectId,
  hideExpandSingle,
  onChangeExpand,
  ...rest
}) => {
  const { data } = useExpensesTotalInfo(parentType, parentId);
  const currencyCode = useSelector((state) => getCurrencyCodeByProjectId(state, projectId));

  return (
    <>
      <ExpenseTotalRealtimeEvents
        parentId={parentId}
        parentType={parentType}
      />
      {data?.yours > 0 || data?.others > 0 ? (
        <ExpenseTotal
          loggedUserTotal={data?.yours}
          othersUserTotal={data?.others}
          hideExpandSingle={hideExpandSingle}
          currencyCode={currencyCode}
          onChangeExpand={onChangeExpand}
          {...rest}
        />
      ) : null}
    </>
  );
};

ExpenseParentTotalContainer.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  hideExpandSingle: PropTypes.bool,
  onChangeExpand: PropTypes.func,
};
